var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadericone5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.364 4.63599C19.7389 5.01104 19.9496 5.51966 19.9496 6.04999C19.9496 6.58032 19.7389 7.08893 19.364 7.46399C19.7923 8.66012 19.8869 9.95026 19.6378 11.1961C19.3887 12.4419 18.8053 13.5965 17.95 14.536L15.828 16.656C15.4415 17.1489 15.1762 17.7256 15.0534 18.3398C14.9306 18.954 14.9538 19.5884 15.121 20.192L3.80798 8.87999C4.41143 9.04704 5.04566 9.0701 5.65965 8.9473C6.27363 8.82451 6.85021 8.55929 7.34298 8.17299L9.46398 6.04999C10.4035 5.1947 11.558 4.61124 12.8039 4.36214C14.0497 4.11304 15.3398 4.20771 16.536 4.63599C16.911 4.26105 17.4197 4.05042 17.95 4.05042C18.4803 4.05042 18.9889 4.26105 19.364 4.63599Z",
    stroke: "#4C5966",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34296 12.414L6.63596 13.121C6.0733 13.6837 5.7572 14.4468 5.7572 15.2425C5.7572 16.0382 6.0733 16.8013 6.63596 17.364C7.19861 17.9267 7.96174 18.2428 8.75746 18.2428C9.55317 18.2428 10.3163 17.9267 10.879 17.364L11.586 16.657",
    stroke: "#4C5966",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadericone5);
export default __webpack_public_path__ + "static/media/headericone5.73863079fda1d48427acb4ea06aac4c2.svg";
export { ForwardRef as ReactComponent };